// extracted by mini-css-extract-plugin
export var resizer = "_e7-0";